var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.85.55,28.29,13a2.51,2.51,0,0,1,.26.31l.06.12a1.27,1.27,0,0,1,.12.23l.05.16.07.21v.78l-.06.2a.49.49,0,0,1-.06.17l-.11.24-.07.13a1.94,1.94,0,0,1-.26.31L15.85,28.27A2,2,0,1,1,13,25.41h0l9-9H2a2,2,0,0,1,0-4H22.06l-9-9a2,2,0,0,1,0-2.83h0A2,2,0,0,1,15.85.55Z","transform":"translate(0 0)"}));
}

ArrowRight.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 28.85 28.85"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
